import { type FC, useState } from 'react'

import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { EquipmentSelector } from './EquipmentSelector'
import { type EquipmentData, type ItAssetModelFinderProps, type SelectedEquipment } from './types'

export { EditEquipmentModal } from './EditEquipmentModal'

export const ItAssetModelFinder: FC<ItAssetModelFinderProps> = ({ target, onSubmit, onClose }) => {
  const [submitting, setSubmitting] = useState(false)
  const [selectedEquipment, setSelectedEquipment] = useState<SelectedEquipment[]>([])
  const [currentSelection, setCurrentSelection] = useState<{
    category: string
    model: string
    equipmentData?: EquipmentData
  }>({
    category: '',
    model: '',
  })

  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const equipment: EquipmentData[] = []

      selectedEquipment.forEach((item) => {
        equipment.push({
          id: item.id,
          brand: item.brand,
          name: item.name,
          typeName: item.typeName,
        })
      })

      if (currentSelection.equipmentData) {
        equipment.push({
          id: currentSelection.equipmentData.id,
          brand: currentSelection.equipmentData.brand,
          name: currentSelection.equipmentData.name,
          typeName: currentSelection.equipmentData.typeName,
        })
      }

      await Promise.resolve(onSubmit(equipment))
    } finally {
      setSubmitting(false)
    }
  }

  const addEquipment = (equipment: SelectedEquipment) => {
    setSelectedEquipment([...selectedEquipment, equipment])
  }

  const handleSelectionChange = (
    category: string,
    model: string,
    equipmentData?: EquipmentData
  ) => {
    setCurrentSelection({ category, model, equipmentData })
  }

  const title = target?.title
    ? i18n.t('job_catalog.equipment.modal.assign_title', { targetName: target.title })
    : i18n.t('job_catalog.equipment.modal.assign_title_default')

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={title}
      primaryAction={{
        label: 'Assign',
        onClick: handleSubmit,
        loading: submitting,
      }}
    >
      <EquipmentSelector
        onAdd={addEquipment}
        selectedEquipment={selectedEquipment}
        onSelectionChange={handleSelectionChange}
      />
    </F0Dialog>
  )
}
